import "../../assets/Badge.css";
import { jsx as a } from "react/jsx-runtime";
const s = "_badge_k7uba_1", t = {
  badge: s
}, r = ({ count: e }) => /* @__PURE__ */ a("div", { className: t.badge, children: e });
export {
  r as Badge
};
